import { render, staticRenderFns } from "./ReinsurersHIstory.vue?vue&type=template&id=20527010&scoped=true&"
import script from "./ReinsurersHIstory.vue?vue&type=script&lang=js&"
export * from "./ReinsurersHIstory.vue?vue&type=script&lang=js&"
import style0 from "./ReinsurersHIstory.vue?vue&type=style&index=0&id=20527010&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20527010",
  null
  
)

export default component.exports